import React, { useEffect } from 'react';
import { useParams } from 'react-router';

import { fetchPostReferralCode } from '#/api/apiExchange';
import { displayWarningNotification } from '#/components/layout/notifications/notificationsUtils';
import { redirectTo } from '#/lib/redirect';
import {
  setReferralCode,
  setReferralCodeApplied,
} from '#/reduxState/currentUserData/userReferral';
import { staticDispatch, useSelector } from '#/reduxState/store';

export default function ReferralAccessRedirectPage() {
  const { code } = useParams<{ code?: string }>();

  const walletAddress = useSelector(state => state.wallet.walletAddress);
  // const [error, setError] = useState('');

  useEffect(() => {
    if (!code) {
      return;
    }
    staticDispatch(setReferralCode(code));
    setTimeout(() => {
      if (!walletAddress) {
        redirectTo('/');
        return;
      }
      // if unlocked, we navigate to referrals page
      fetchPostReferralCode(walletAddress, code)
        .then(result => {
          console.log('[ReferralAccessRedirectPage] Redeem', result);
          redirectTo('/rewards/referrals');
          staticDispatch(setReferralCodeApplied(true));
        })
        .catch(error => {
          console.warn(
            `Failed to apply saved referral code: ${code}: `,
            error.idexErrorCode,
            error
          );
          switch (error.idexErrorCode) {
            case 'REFERRAL_CODE_NOT_FOUND':
            case 'INVALID_CIRCULAR_REFERRAL_ERROR':
            case 'INVALID_SELF_REFERRAL_ERROR':
            case 'WALLET_ALREADY_REFERRED': {
              // we can remove the code from state in this case
              staticDispatch(setReferralCode(undefined));
              displayWarningNotification(error.message);
              // staticDispatch(displayGlobalError(error.message, 'warning', ''));
              redirectTo('/');
              return;
            }
            default:
              break;
          }
          displayWarningNotification(error.message);
          // staticDispatch(displayGlobalError(error.message, 'warning', ''));
          // setError(error.message);
        });
    });
  }, [code, walletAddress]);

  if (!code) {
    console.error('Missing referral code');
    return <h1>Incorrect referral code</h1>;
  }

  return null;
  // return error ? <WelcomeCodeInvalidModal errorMessage={error} /> : null;
}
